<ng-container *ngIf="isEditable(); else viewMode">
  <div style="display: flex">
    <div class="currency-symbol">{{currencySymbol}}</div>
    <mat-form-field *ngIf="control">
      <input type="text" matInput pqmNumberInput [formControl]="control"/>
      <mat-error *ngIf="hasErrors()">{{getErrors()}}</mat-error>
    </mat-form-field>
  </div>
</ng-container>

<ng-template #viewMode>
  <div class="c-overview-details-grid__value">
    {{displayValue}}
  </div>
</ng-template>

